import { render, staticRenderFns } from "./NationalTrademarkRenewalsList.vue?vue&type=template&id=044ca2d8&"
import script from "./NationalTrademarkRenewalsList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkRenewalsList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkRenewalsList.vue?vue&type=style&index=0&id=044ca2d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports